"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const modal_1 = __importDefault(require("@kawaui/modal"));
const react_1 = require("react");
const styled_components_1 = require("styled-components");
const use_media_1 = __importDefault(require("use-media"));
const discard_1 = __importDefault(require("./components/discard"));
const header_1 = __importDefault(require("./components/header"));
const item_carousel_1 = __importDefault(require("./components/item-carousel"));
const notification_1 = __importStar(require("./components/notification"));
const recover_1 = __importDefault(require("./components/recover"));
const context_1 = require("./context");
const styles_1 = require("./styles");
const utils_1 = require("./utils");
const mixpanel_1 = require("./utils/mixpanel");
const defaultOnRouting = (url) => {
    window.location.href = url;
};
const ExpiredCartDialog = ({ open, onClose, items, recover, cancelRecover, isHardChoice = false, onRouting = defaultOnRouting, isCartPage, track, i18n, }) => {
    var _a;
    const { item_list: itemList } = items !== null && items !== void 0 ? items : {};
    const [checkList, setCheckList] = (0, react_1.useState)((_a = itemList === null || itemList === void 0 ? void 0 : itemList.reduce(utils_1.checklistReducer, {})) !== null && _a !== void 0 ? _a : {});
    const [notificationOpen, setNotificationOpen] = (0, react_1.useState)(false);
    const theme = (0, styled_components_1.useTheme)();
    const isMobile = (0, use_media_1.default)({ maxWidth: theme.breakpoint.tablet });
    const closeNotification = () => setNotificationOpen(false);
    const size = isMobile ? 'large' : 'medium';
    const title = i18n(isHardChoice ? 'cart_expired.hard.title' : 'cart_expired.soft.title');
    const paragraph = i18n(isHardChoice ? 'cart_expired.hard.text' : 'cart_expired.soft.text');
    (0, react_1.useEffect)(() => {
        if (open && items)
            track(...(0, mixpanel_1.expiredRender)(items, isHardChoice));
    }, [open]);
    const onRecover = (list) => {
        if (items)
            track(...(0, mixpanel_1.recoverClick)(items, list, isHardChoice));
        return recover((0, utils_1.getDiscarded)(list));
    };
    const onDiscard = () => {
        track(...(0, mixpanel_1.discardClick)());
        return cancelRecover();
    };
    const onToggle = (selected) => {
        track(...(0, mixpanel_1.selectProduct)(selected, isHardChoice));
    };
    const handleClose = () => {
        track(...(0, mixpanel_1.closeModal)());
        onClose();
    };
    const handleUnSelection = () => {
        track(...(0, mixpanel_1.unselectedError)());
        setNotificationOpen(true);
    };
    return ((0, jsx_runtime_1.jsx)(modal_1.default, { disableBackdropEvents: true, onClose: handleClose, open: open, children: (0, jsx_runtime_1.jsxs)(context_1.ExpiredContextProvider, { checkList: checkList, setCheckList: setCheckList, onUnselected: handleUnSelection, children: [(0, jsx_runtime_1.jsxs)(styles_1.Container, { isHardChoice: isHardChoice, children: [!isHardChoice && (0, jsx_runtime_1.jsx)(header_1.default, { onClose: onClose }), (0, jsx_runtime_1.jsx)("div", { id: notification_1.CONTAINER_ID }), (0, jsx_runtime_1.jsx)(styles_1.Title, { children: title }), (0, jsx_runtime_1.jsx)(styles_1.Paragraph, { children: paragraph }), itemList && (0, jsx_runtime_1.jsx)(item_carousel_1.default, { items: itemList, onToggle: onToggle, i18n: i18n }), (0, jsx_runtime_1.jsxs)(styles_1.Footer, { isMobile: isMobile, children: [(0, jsx_runtime_1.jsx)(discard_1.default, { onDiscard: onDiscard, isHardChoice: isHardChoice, size: size, i18n: i18n }), isHardChoice && (0, jsx_runtime_1.jsx)(styles_1.Separator, {}), (0, jsx_runtime_1.jsx)(recover_1.default, { onRecover: onRecover, onRouting: onRouting, size: size, isCartPage: isCartPage, i18n: i18n })] })] }), (0, jsx_runtime_1.jsx)(notification_1.default, { open: notificationOpen, onClose: closeNotification, i18n: i18n })] }) }));
};
exports.default = ExpiredCartDialog;
